<template>
    <panel
        :panel="this.panel" />
</template>

<script>
    import Panel from '../Panel';

    export default {
        props: {
            panel: Object
        },
        components: {
            Panel
        }
    }
</script>
